import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import { TextField, Switch, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, MenuItem, Select } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import { Paper } from "@material-ui/core";
import Player from "../Player";
import ColorPicker from "material-ui-color-picker";
import request from "superagent";
import { baseUrlPlugPlayer, blogPlayClientType, defaultPaperPadding, maxAudioTracksSize, plugClientType, urlPlayerPreview, urlTTSPlayerPreview, url_endpoint } from "../../config";
import authHeader from "../Utils/AuthHeader";
import LoaderSpinner from "../../componentes/LoaderSpinner";
import { catchClause } from "@babel/types";
import checkLogin from "../Utils/checkLogin";
import palette from "../../theme/palette";
import { AddCircle, Assignment } from "@material-ui/icons";
import { SelectableCard } from "./campaigns/components/SelectableCard";
import WomanIcon from '../../images/icons/woman_icon.svg'
import ManIcon from '../../images/icons/man_icon.svg'

class Configuracoes extends Component {
  constructor(props) {
    super(props);

    this.props.setTitulo("Configurações");

    this.state = {
      client: null,
      configs: {
        id: 0,
        clientType: 0,
        layout: "2",
        corbotoes: "#918C8C",
        cortexto: "#FFFFFF",
        corfundo: "#6A6A6A", //"#fff",
        cortextoselecionado: "#fff",
        cortitulo: "#fff",
        corsecundaria: "#fff",
        solicitarEmail: false,
        permitirDownload: true,
        gtmTag: '',
        addBackgroundAudio: false,
        randomBackgroundAudio: true,
        backgroundAudioId: null,
        ttsGender: 'M',
      },
      plugMainColor: '#ffab05',
      oldPlugMainColor: '#ffab05',
      ttsGenderOptions: [
        { label: 'Masculino', value: 'M' },
        { label: 'Feminino', value: 'F' },
      ],
      startAudioFile: null,
      endAudioFile: null,
      posts: [],
      loading: false,
      generalDialogOpen: false,
      generalDialogTitle: '',
      generalDialogMessage: '',
      // List of objects
      // Format = {id: int, label: string, path: string}
      backgroundAudios: [],
    };
  }

  async componentDidMount() {
    try {
      await checkLogin(false)

      this.setState({ loading: true });

      const res = await request
        .get(url_endpoint + "podcast/all")
        .set(authHeader());
      const cliente = await request
        .get(url_endpoint + "cliente/me")
        .set(authHeader());

      const backgroundAudiosReq = await request.get(url_endpoint + 'backgroundAudios/all').set(authHeader())

      let body = cliente.body
      body.addBackgroundAudio = body.addBackgroundAudio == 1
      body.randomBackgroundAudio = body.randomBackgroundAudio == 1
      this.setState({ loading: false, client: cliente.body, oldPlugMainColor: body.plugMainColor, plugMainColor: body.plugMainColor });

      // console.log("cliente.body=", JSON.stringify(cliente.body));

      this.setState({ posts: res.body, configs: cliente.body, backgroundAudios: backgroundAudiosReq.body });
    } catch (err) {
      this.setState({ loading: false });

      console.log(err);
    }
  }

  formChange = async (name, val) => {
    try {
      const configs = this.state.configs;
      configs[name] = val;
      await request
        .patch(url_endpoint + "cliente/player")
        .set(authHeader())
        .send({ [name]: val });
      this.setState({ configs });
    } catch (e) {
      console.log(e);
    }
  };

  validateBackgroundData() {
    const addBackground = this.state.configs.addBackgroundAudio
    const randomBackground = this.state.configs.randomBackgroundAudio
    const backgroundAudioId = this.state.configs.backgroundAudioId

    // Case the add background is false, none data is required
    if (addBackground == false) {
      return true
    }
    // Case the backround is random, none data is required
    if (randomBackground) {
      return true
    }
    // Case the background isn't random, a specific audio is required
    if (randomBackground == false && backgroundAudioId == null) {
      this.setState({ generalDialogOpen: true, generalDialogTitle: 'Nenhum áudio selecionado para o background', generalDialogMessage: `Caso o background não seja aleatório, um áudio precisa ser selecionado` })
      return false
    }

    return true
  }

  async saveBackground() {
    const validData = this.validateBackgroundData()

    if (!validData) {
      return;
    }

    try {
      this.setState({ loading: true })

      const reqMount = request.post(url_endpoint + 'cliente/updateBackgroundConfig')
        .field('addBackgroundAudio', this.state.configs.addBackgroundAudio)
        .field('randomBackgroundAudio', this.state.configs.randomBackgroundAudio)
        .set(authHeader())

      if (this.state.configs.backgroundAudioId != null) {
        reqMount.field('backgroundAudioId', this.state.configs.backgroundAudioId)
      }

      const res = await reqMount

      this.setState({ loading: false, generalDialogOpen: true, generalDialogTitle: 'Sucesso', generalDialogMessage: 'Configurações de background atualizadas com sucesso' })
    } catch (err) {
      console.log(err)
      const msg = err.response.text
      this.setState({ loading: false, generalDialogOpen: true, generalDialogTitle: 'Erro ao atualizar as configurações de background', generalDialogMessage: msg })
    }
  }

  async saveAudios() {
    const startAudioExists = this.state.startAudioFile != null && this.state.startAudioFile != undefined
    const endAudioExists = this.state.endAudioFile != null && this.state.endAudioFile != undefined

    if (!startAudioExists && !endAudioExists) {
      return
    }

    try {
      this.setState({ loading: true })

      const res = await request.post(url_endpoint + 'cliente/updateAudios')
        .set(authHeader())
        .attach('audioStart', this.state.startAudioFile)
        .attach('audioEnd', this.state.endAudioFile)

      this.setState({ loading: false, generalDialogOpen: true, generalDialogTitle: 'Sucesso ao atualizar áudios', generalDialogMessage: 'Áudios atualizados com sucesso', startAudioFile: null, endAudioFile: null, client: res.body })
    } catch (err) {
      const msg = err.response.text
      this.setState({ loading: false, generalDialogOpen: true, generalDialogTitle: 'Erro ao atualizar áudios', generalDialogMessage: msg })
    }
  }

  fileSizeInLimit(file, limit) {
    const fileSizeInMB = file.size / 1000000

    return fileSizeInMB < limit
  }

  render() {
    if (this.state.loading) {
      return (<LoaderSpinner />)
    } else {
      if (this.state.configs.clientType == plugClientType) {
        return (
          <Grid container spacing={3} >
            <Dialog
              open={this.state.generalDialogOpen}
              onClose={() => {
                this.setState({ generalDialogOpen: false })
              }}
            >
              <DialogTitle>
                <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.generalDialogTitle}</span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <span style={{ fontSize: '14px' }}>{this.state.generalDialogMessage}</span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <span onClick={() => {
                  this.setState({ generalDialogOpen: false })
                }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                  {"OK"}
                </span>
              </DialogActions>
            </Dialog>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '30px', alignItems: 'flex-start', color: '#6c6c6c' }}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Paper style={{ padding: defaultPaperPadding, color: '#6c6c6c' }}>
                  <h2 style={{ marginBottom: '5px' }}>Exemplo de player (Exemplo ilustrativo)</h2>
                  <iframe style={{ border: 'none', width: '100%', height: '76px' }} src={`${urlTTSPlayerPreview}&mainColor=${encodeURIComponent(this.state.plugMainColor)}`}></iframe>
                  <div style={{ margin: '15px 0', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <h2>Personalização da cor do player</h2>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexWrap: 'wrap' }}>
                      <h3 for="plug-main-color">Cor do player:</h3>
                      <input value={this.state.plugMainColor} type="color" id='plug-main-color' onChange={(evt) => this.setState({ plugMainColor: evt.target.value })}></input>
                    </div>
                    {this.state.oldPlugMainColor != this.state.plugMainColor &&
                      <Button style={{ alignSelf: 'flex-start' }} variant="contained" color="primary" onClick={async () => {
                        this.setState({ loading: true })
                        await this.formChange('plugMainColor', this.state.plugMainColor)
                        this.setState({ loading: false, oldPlugMainColor: this.state.plugMainColor })
                      }}>Salvar cor</Button>
                    }
                  </div>
                  <h2>Personalização das funções do player</h2>
                  <div style={{ margin: '15px 0', display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
                    <h3>Captação de Leads</h3>
                    <h3>Solicitar email antes de executar o áudio</h3>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={this.state.configs.solicitarEmail}
                          onChange={() => this.formChange('solicitarEmail', !this.state.configs.solicitarEmail)}
                        ></Switch>
                      }
                      label="Solicitar E-mail"
                      labelPlacement="end"
                    ></FormControlLabel>
                  </div>
                  <div style={{ margin: '15px 0', display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
                    <h3>Download do Conteúdo</h3>
                    <h3>Permitir que o usuário faça download do áudio</h3>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={this.state.configs.permitirDownload}
                          onChange={() => this.formChange('permitirDownload', !this.state.configs.permitirDownload)}
                        ></Switch>
                      }
                      label="Permitir Download"
                      labelPlacement="end"
                    ></FormControlLabel>
                  </div>
                  {/* <divider style={{ marginBottom: '15px', display: 'flex', height: '2px', backgroundColor: 'lightgrey' }}></divider> */}
                  <divider style={{ display: 'flex', height: '2px', backgroundColor: 'lightgrey' }}></divider>
                  <h2 style={{ color: "#6c6c6c", marginTop: 15, marginBottom: 10 }}>Código de implantação</h2>
                  <textarea style={{ width: "100%", height: "120px", borderColor: palette.primary.main, borderRadius: '10px', padding: '10px', resize: 'none', outline: 0 }} readOnly={true} value={`<iframe id="plugIframe" style="height: 115px; min-width: 100%; border:none;" src="${baseUrlPlugPlayer}?id=${this.state.configs.id}"></iframe>\n<script src="https://plug-blogplay.s3.amazonaws.com/startPlug.js"></script>`}></textarea>
                  <IconButton style={{ padding: '0' }} onClick={navigator.clipboard.writeText(`<iframe id="plugIframe" style="height: 115px; min-width: 100%; border:none;" src="${baseUrlPlugPlayer}?id=${this.state.configs.id}"></iframe>\n<script src="https://plug-blogplay.s3.amazonaws.com/startPlug.js"></script>`)}>
                    <Assignment />
                  </IconButton>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Paper style={{ padding: defaultPaperPadding, color: '#6c6c6c' }}>
                  <h2 style={{ marginBottom: '5px' }}>Personalização de Áudio</h2>
                  <h3>Personalize a voz, adicione uma abertura ou/e conclusão, e adicione trilha sonora ao seu áudio. </h3>
                  <div style={{ margin: '15px 0', display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
                    <h3>Gênero da Voz</h3>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                      <SelectableCard icon={WomanIcon} label="Voz Feminina" description="" selected={this.state.configs.ttsGender == 'F'} onChange={(val) => {
                        if (val == false) {
                          return
                        }

                        let configs = this.state.configs
                        configs.ttsGender = 'F'

                        this.formChange('ttsGender', 'F')

                        this.setState({ configs: configs })
                      }}></SelectableCard>
                      <SelectableCard icon={ManIcon} label="Voz Masculina" description="" selected={this.state.configs.ttsGender == 'M'} onChange={(val) => {
                        if (val == false) {
                          return
                        }

                        let configs = this.state.configs
                        configs.ttsGender = 'M'

                        this.formChange('ttsGender', 'M')

                        this.setState({ configs: configs })
                      }}></SelectableCard>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                    <h3 style={{ color: "#6c6c6c", marginTop: 15, marginBottom: 10 }}>Abertura e Conclusão</h3>
                    <label htmlFor="startAudioInput" style={{ display: 'flex', alignItems: 'center', fontSize: '15px', border: '1px solid lightgrey', borderRadius: '5px', boxShadow: '0 0 2px lightgrey', padding: '8px', cursor: 'pointer' }}>
                      <span style={{ fontWeight: 'bold' }}>Abertura: <span style={{ fontWeight: 'normal', color: palette.primary.main, textDecoration: 'underline', textUnderlineOffset: '2px' }}>{(this.state.startAudioFile != null && this.state.startAudioFile != undefined) ? this.state.startAudioFile.name : this.state.client.audioStartName ?? 'Adicionar áudio de abertura'}</span></span>
                      <AddCircle style={{ color: palette.primary.main, marginLeft: '5px' }}></AddCircle>
                    </label>
                    <input
                      accept="audio/mp3"
                      id="startAudioInput"
                      type="file"
                      style={{ display: 'none' }}
                      onChange={(evt) => {
                        if (evt.target.files.length == 0) {
                          return this.setState({ startAudioFile: null })
                        }

                        const file = evt.target.files[0]

                        const validSize = this.fileSizeInLimit(file, maxAudioTracksSize)

                        if (!validSize) {
                          return this.setState({ generalDialogOpen: true, generalDialogTitle: 'Arquivo muito grande', generalDialogMessage: `O arquivo ultrapassa o limite de ${maxAudioTracksSize} megabytes` })
                        }

                        this.setState({ startAudioFile: file })
                      }}
                    />

                    <label htmlFor="endAudioInput" style={{ display: 'flex', alignItems: 'center', fontSize: '15px', border: '1px solid lightgrey', borderRadius: '5px', boxShadow: '0 0 2px lightgrey', padding: '8px', cursor: 'pointer' }}>
                      <span style={{ fontWeight: 'bold' }}>Encerramento: <span style={{ fontWeight: 'normal', color: palette.primary.main, textDecoration: 'underline', textUnderlineOffset: '2px' }}>{(this.state.endAudioFile != null && this.state.endAudioFile != undefined) ? this.state.endAudioFile.name : this.state.client.audioEndName ?? 'Adicionar áudio de abertura'}</span></span>
                      <AddCircle style={{ color: palette.primary.main, marginLeft: '5px' }}></AddCircle>
                    </label>
                    <input
                      accept="audio/mp3"
                      id="endAudioInput"
                      type="file"
                      style={{ display: 'none' }}
                      onChange={(evt) => {
                        if (evt.target.files.length == 0) {
                          return this.setState({ endAudioFile: null })
                        }

                        const file = evt.target.files[0]

                        const validSize = this.fileSizeInLimit(file, maxAudioTracksSize)

                        if (!validSize) {
                          return this.setState({ generalDialogOpen: true, generalDialogTitle: 'Arquivo muito grande', generalDialogMessage: `O arquivo ultrapassa o limite de ${maxAudioTracksSize} megabytes` })
                        }

                        this.setState({ endAudioFile: file })
                      }}
                    />
                    <Button style={{ alignSelf: 'start' }} variant="contained" color="primary" component="span" onClick={() => this.saveAudios()}>
                      Salvar áudios
                    </Button>
                  </div>

                  <div style={{ margin: '15px 0', display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                    <h3>Trilha</h3>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={this.state.configs.addBackgroundAudio}
                          onChange={() => {
                            let configs = this.state.configs
                            configs.addBackgroundAudio = !configs.addBackgroundAudio
                            configs.randomBackgroundAudio = configs.addBackgroundAudio
                            configs.backgroundAudioId = null
                            this.setState({ configs: configs })
                            this.saveBackground()
                          }}
                        ></Switch>
                      }
                      label="Adicionar Trilha"
                      labelPlacement="end"
                    ></FormControlLabel>
                    {/* {this.state.configs.addBackgroundAudio &&
                    <>
                      <FormLabel>Aleatório</FormLabel>
                      <Switch
                        color="primary"
                        checked={this.state.configs.randomBackgroundAudio}
                        onChange={() => {
                          let configs = this.state.configs
                          configs.randomBackgroundAudio = !configs.randomBackgroundAudio
                          configs.backgroundAudioId = null
                          this.setState({ configs: configs })
                        }}
                      ></Switch>
                    </>
                  }

                  <br />

                  {this.state.configs.addBackgroundAudio && !this.state.configs.randomBackgroundAudio &&
                    <>
                      <FormLabel style={{ marginRight: '5px' }}>Áudio</FormLabel>
                      <Select
                        id="background-audio-select"
                        value={this.state.backgroundAudios.find((a) => a.id == this.state.configs.backgroundAudioId)}
                        onChange={(evt) => {
                          let configs = this.state.configs
                          configs.backgroundAudioId = evt.target.value.id

                          const audioElem = document.querySelector('audio')
                          if (audioElem != null) {
                            audioElem.load()
                          }

                          this.setState({ configs: configs })
                        }}
                      >
                        {this.state.backgroundAudios.map((a) => <MenuItem value={a}>{a.label}</MenuItem>)}
                      </Select>
                    </>
                  }
                  <br /> */}

                    {/* {this.state.configs.backgroundAudioId != null &&
                    <audio style={{ width: '100%' }} controls>
                      <source src={this.state.backgroundAudios.find((a) => a.id == this.state.configs.backgroundAudioId).path} type="audio/mpeg" />
                    </audio>
                  } */}

                    {/* <Button style={{ alignSelf: 'start' }} variant="contained" color="primary" component="span" onClick={() => this.saveBackground()}>
                      Salvar background
                    </Button> */}
                  </div>
                </Paper>
              </Grid>
            </div>
          </Grid>
        )
      }
      if (this.state.configs.clientType == blogPlayClientType) {
        return (
          <div>
            <Dialog
              open={this.state.generalDialogOpen}
              onClose={() => {
                this.setState({ generalDialogOpen: false })
              }}
            >
              <DialogTitle>
                <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.generalDialogTitle}</span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <span style={{ fontSize: '14px' }}>{this.state.generalDialogMessage}</span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <span onClick={() => {
                  this.setState({ generalDialogOpen: false })
                }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                  {"OK"}
                </span>
              </DialogActions>
            </Dialog>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <h1>Configurações do player</h1>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Paper style={{ padding: defaultPaperPadding }}>
                  <h2 style={{ color: "#6c6c6c", marginTop: 0 }}>Layout</h2>
                  <RadioGroup
                    aria-label="layout"
                    name="layout"
                    value={this.state.configs.layout}
                    onChange={(evt) => this.formChange("layout", evt.target.value)}
                  >
                    <FormControlLabel
                      value="0"
                      control={<Radio color="primary" />}
                      label="Completo"
                    />
                    <FormControlLabel
                      value="1"
                      control={<Radio color="primary" />}
                      label="Mínimo com background"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="primary" />}
                      label="Mínimo sem background"
                    />
                    <FormControlLabel
                      value="3"
                      control={<Radio color="primary" />}
                      label="Mínimo sem títutlo"
                    />
                  </RadioGroup>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Paper style={{ padding: defaultPaperPadding }}>
                  <h2 style={{ color: "#6c6c6c", marginTop: 0, marginBottom: 10 }}>Cores</h2>
                  <FormLabel component="legend">Botões</FormLabel>
                  <ColorPicker
                    name="color"
                    defaultValue="#000"
                    value={this.state.configs.corbotoes}
                    onChange={(color) =>
                      color && this.formChange("corbotoes", color)
                    }
                  />
                  <div style={{ marginTop: 20 }}>
                    <FormLabel component="legend">Cor Secundária</FormLabel>
                    <ColorPicker
                      name="color"
                      defaultValue="#000"
                      value={this.state.configs.corsecundaria}
                      onChange={(color) =>
                        color && this.formChange("corsecundaria", color)
                      }
                    />
                  </div>
                  {(this.state.configs.layout != "3") && (
                    <div style={{ marginTop: 20 }}>
                      <FormLabel component="legend">Título</FormLabel>
                      <ColorPicker
                        name="color"
                        defaultValue="#fff"
                        value={this.state.configs.cortitulo}
                        onChange={(color) => this.formChange("cortitulo", color)}
                      />
                    </div>
                  )}
                  <div style={{ marginTop: 20 }}>
                    <FormLabel component="legend">Texto</FormLabel>
                    <ColorPicker
                      name="color"
                      defaultValue="#000"
                      value={this.state.configs.cortexto}
                      onChange={(color) => this.formChange("cortexto", color)}
                    />
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <FormLabel component="legend">Velocidade Selecionada</FormLabel>
                    <ColorPicker
                      name="color"
                      defaultValue="#000"
                      value={this.state.configs.cortextoselecionado}
                      onChange={(color) =>
                        this.formChange("cortextoselecionado", color)
                      }
                    />
                  </div>
                  {(this.state.configs.layout === "2" ||
                    this.state.configs.layout === "3") && (
                      <div style={{ marginTop: 20 }}>
                        <FormLabel component="legend">Fundo</FormLabel>
                        <ColorPicker
                          name="color"
                          defaultValue="#000"
                          value={this.state.configs.corfundo}
                          onChange={(color) => this.formChange("corfundo", color)}
                        />
                      </div>
                    )}
                  <h2 style={{ color: "#6c6c6c", marginTop: 15, marginBottom: 10 }}>Email</h2>
                  <FormLabel>Solicitar Email</FormLabel>
                  <Switch
                    color="primary"
                    checked={this.state.configs.solicitarEmail}
                    onChange={() => this.formChange('solicitarEmail', !this.state.configs.solicitarEmail)}
                  ></Switch>
                  <h2 style={{ color: "#6c6c6c", marginTop: 15, marginBottom: 10 }}>Download</h2>
                  <FormLabel>Permitir Download</FormLabel>
                  <Switch
                    color="primary"
                    checked={this.state.configs.permitirDownload}
                    onChange={() => this.formChange('permitirDownload', !this.state.configs.permitirDownload)}
                  ></Switch>
                  <h2 style={{ color: "#6c6c6c", marginTop: 15, marginBottom: 10 }}>Tag manager</h2>
                  <FormLabel>Código do projeto</FormLabel>
                  <TextField value={this.state.configs.gtmTag} onChange={(event) => this.formChange('gtmTag', event.target.value)}></TextField>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} style={{ lineHeight: 1.2 }}>
                <Paper>
                  {this.state.posts.length > 0 ? (
                    <Player
                      layout={this.state.configs.layout}
                      cortextoselecionado={this.state.configs.cortextoselecionado}
                      cortexto={this.state.configs.cortexto}
                      corbotoes={this.state.configs.corbotoes}
                      corfundo={this.state.configs.corfundo}
                      cortitulo={this.state.configs.cortitulo}
                      corsecundaria={this.state.configs.corsecundaria}
                      match={{ params: { id: this.state.posts[0].id } }}
                      permitirDownload={this.state.configs.permitirDownload}
                    />
                  ) : (
                    <span>
                      Visualização desativada, é necessário um post para
                      pré-visualização
                    </span>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </div>
        );
      }
    }
  }
}

export default Configuracoes;
